export default {
  MuiCardMedia: {
    styleOverrides: {
      root: {
        height: 'auto',
      },
    },
  },
}
